import { render, staticRenderFns } from "./e-chip-status.vue?vue&type=template&id=7b1c95d4&scoped=true&lang=pug"
import script from "./e-chip-status.vue?vue&type=script&lang=js"
export * from "./e-chip-status.vue?vue&type=script&lang=js"
import style0 from "./e-chip-status.vue?vue&type=style&index=0&id=7b1c95d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c95d4",
  null
  
)

export default component.exports